import { CoreInput } from '@/components/Form/InputAntForm';
import CoreSelect from '@/components/Form/SelectAntForm';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import React from 'react';
import { useFieldArray } from 'react-hook-form';

interface Props {
  control: any;
  name: string;
  className?: string;
  disabled?: boolean;
}

// Danh sách các giá trị params có sẵn
const PARAM_OPTIONS = [
  { value: 'USER_BU_LIST', label: 'User Business Unit' },
  { value: 'USER_BA', label: 'User BA' },
  { value: 'DATE_FROM', label: 'Date from' },
  { value: 'DATE_TO', label: 'Date to' },
  // { value: 'USER_BU_AREA_LIST', label: 'User Business Area' },
  // { value: 'USER_ROLE_LIST', label: 'User Role' }
];

export const DynamicParamsForm: React.FC<Props> = (props) => {
  const { control, name, className, disabled } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const handleAddParam = () => {
    append({ name: '', value: '' });
  };

  const handleRemoveParam = (index: number) => {
    remove(index);
  };

  return (
    <div className={className}>
      <div className='flex justify-between items-center mb-4'>
        <Typography.Text className='font-medium'>Dynamic Parameters</Typography.Text>
        <Button
          type='dashed'
          onClick={handleAddParam}
          icon={<PlusOutlined />}
          disabled={disabled}
          size='small'
        >
          Add Parameter
        </Button>
      </div>

      {fields.length === 0 && (
        <div className='text-gray-400 text-center py-4 border border-dashed border-gray-300 rounded'>
          No parameters added yet
        </div>
      )}
      {fields.map((field, index) => (
        <div key={field.id} className='border border-gray-200 rounded p-4 mb-4 bg-gray-50'>
          <div className='flex justify-between items-start mb-3'>
            <Typography.Text className='font-medium'>Parameter {index + 1}</Typography.Text>
            <Button
              type='text'
              danger
              size='small'
              icon={<DeleteOutlined />}
              onClick={() => handleRemoveParam(index)}
              disabled={disabled}
            />
          </div>

          <div className='grid grid-cols-2 gap-4'>
            <CoreInput
              control={control}
              name={`${name}.${index}.name`}
              label='Parameter Name'
              placeholder='Enter parameter name'
              className='w-full'
              disabled={disabled}
            />

            <CoreSelect
              control={control}
              name={`${name}.${index}.value`}
              label='Parameter Value'
              placeholder='Select parameter value'
              optionsProps={PARAM_OPTIONS}
              className='w-full'
              disabled={disabled}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
